// Clipuri derulate la scroll (hero-ul și scena de final): încărcare pe rând, amorsare pe iOS, seek lin.
import { MOMENTE } from './momente.js'

export const ramp = (a, b, x) => Math.min(1, Math.max(0, (x - a) / (b - a)))
export const MOBIL = typeof window !== 'undefined' && window.matchMedia('(max-width:760px)').matches

// vids[k] arată momentul idx[k] din MOMENTE
export const makeScrubber = (vids, idx) => {
    const tCur = vids.map(() => -1)
    let gest = false

    // MOBIL (iOS): video-ul nu randează cadre la currentTime până nu e „amorsat" cu un
    // play()/pause() dintr-un gest. Clipurile încărcate mai târziu se amorsează la următoarea atingere.
    const prime = (v) => {
        if (v.dataset.primed) return
        v.dataset.primed = '1'
        const pr = v.play()
        if (pr && typeof pr.then === 'function') pr.then(() => { try { v.pause() } catch (e) { /* ok */ } }).catch(() => { v.dataset.primed = '' })
    }
    const onGesture = () => { gest = true; vids.forEach((v) => { if (v.dataset.on) prime(v) }) }

    const load = (k) => {
        const v = vids[k]
        if (!v || v.dataset.on) return
        v.dataset.on = '1'
        const m = MOMENTE[idx[k]]
        v.src = MOBIL ? m.srcMobil : m.src
        v.preload = 'auto'
        v.load()
        if (gest) prime(v)
    }

    // seek lin spre ținta din scroll; nu trimitem un seek nou cât cel curent nu s-a terminat
    // (setarea repetată a currentTime în timpul unui seek face backlog și agățare)
    const seek = (k, target) => {
        const v = vids[k]
        if (!v || !v.duration) return
        const tt = target * v.duration
        if (tCur[k] < 0) tCur[k] = tt
        tCur[k] += (tt - tCur[k]) * 0.2
        if (Math.abs(tt - tCur[k]) < 0.006) tCur[k] = tt
        if (!v.seeking && Math.abs(v.currentTime - tCur[k]) > 0.015) {
            try { v.currentTime = tCur[k] } catch (e) { /* seek în curs */ }
        }
    }

    window.addEventListener('touchstart', onGesture, { passive: true })
    window.addEventListener('pointerdown', onGesture)
    const stop = () => {
        window.removeEventListener('touchstart', onGesture)
        window.removeEventListener('pointerdown', onGesture)
    }
    return { load, seek, stop }
}

// textul unui moment: --k = cât a intrat (0..1), stilul din CSS decide ce face cu el
export const showCap = (c, op, k) => {
    c.style.opacity = op
    c.style.setProperty('--k', k)
    c.style.pointerEvents = op > 0.5 ? 'auto' : 'none'
}
